import React from "react";

const CreditIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.33333 2.5C2.8731 2.5 2.5 2.8731 2.5 3.33333C2.5 3.79357 2.8731 4.16667 3.33333 4.16667L12.6667 4.16667C13.6792 4.16667 14.5 4.98748 14.5 6V12.6667C14.5 13.6792 13.6792 14.5 12.6667 14.5H3.33333C2.32081 14.5 1.5 13.6792 1.5 12.6667V3.33333C1.5 2.32081 2.32081 1.5 3.33333 1.5H11.3333C11.6095 1.5 11.8333 1.72386 11.8333 2C11.8333 2.27614 11.6095 2.5 11.3333 2.5H3.33333ZM2.5 4.96676V12.6667C2.5 13.1269 2.8731 13.5 3.33333 13.5H12.6667C13.1269 13.5 13.5 13.1269 13.5 12.6667V6C13.5 5.53976 13.1269 5.16667 12.6667 5.16667L3.33333 5.16667C3.03326 5.16667 2.75002 5.09457 2.5 4.96676ZM10.1667 9.33333C10.1667 8.8731 10.5398 8.5 11 8.5C11.4602 8.5 11.8333 8.8731 11.8333 9.33333C11.8333 9.79357 11.4602 10.1667 11 10.1667C10.5398 10.1667 10.1667 9.79357 10.1667 9.33333Z"
        fill="#FD7A41"
      />
    </svg>
  );
};

export default CreditIcon;
